import { createContext } from "react";

const RoleContext = createContext();

export default RoleContext;
